<template>
    <div>
      <el-card v-loading="loading" class="box">
        <!-- <h3>订购商品</h3> -->
        <div class="head">
          <el-input
          v-model="input"
          size="mini"
          style="width: 110px; margin-right: 20px"
          placeholder="请输入">
          </el-input>
          <el-button type="primary" size="mini" @click="search" icon="el-icon-search" style="margin-right:550px">搜索</el-button>
          <!-- <el-button type="primary" size="mini" @click="reset()" icon="el-icon-refresh">重置</el-button> -->
          <!-- <el-button type="primary" size="mini" icon="el-icon-download" @click="export_">导出数据</el-button> -->
          <!-- <div class="block">
            <el-date-picker
              size="mini"
              style="width:200px;margin-right:550px"
              @change="block"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="value1"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div> -->

          <!-- 请选择站点 -->
          <el-select size="mini" v-model="selectSite" multiple placeholder="请选择站点">
            <el-option
              v-for="item in Site"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <!-- 请选择订单状态 -->
          <el-select size="mini" style="margin-left: 10px" v-model="selectListStatus" multiple placeholder="请选择订单状态">
            <el-option
              v-for="item in ListStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <!-- 请选择商品状态 -->
          <el-select size="mini" style="margin-left: 10px" v-model="selectProductStatus" multiple placeholder="请选择商品状态">
            <el-option
              v-for="item in ProductStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <!-- 请选择物流商 -->
          <el-select size="mini" style="margin-left: 10px" v-model="selectWLS" multiple placeholder="请选择物流商">
            <el-option
              v-for="item in WLS"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="CXDD" style="margin-left: 10px">查询订单</el-button>

        </div>

        <el-table
          height="680"
          :data="tableData"
          border
          style="width: 100%;border: 1px solid #000000"
          :row-style="{height:'100px'}"
          :cell-style="{padding:0,borderColor:'#000000'}"
          :header-cell-style="{borderColor:'#000000',color:'#0099ff'}"
          @selection-change="selectionChange"
          :default-sort = "{prop: 'date_created_gmt', order: 'descending'}"
        >
          <!-- :row-class-name="RowNumber" -->

          <!-- 全选按钮 -->
          <el-table-column
            align="center"
            type="selection"
            label="全选"
            width="40px">
          </el-table-column>

          <!-- 站点 -->
          <!-- :filter-method="filter"
          :filters="[{ text: 'madrid-shop', value: 'madrid-shop' }, { text: 'cuirz', value: 'cuirz' }, { text: 'nihonbro', value: 'nihonbro' }, { text: 'jleague-shop', value: 'jleague-shop' }, { text: 'supermaillot', value: 'supermaillot' }, { text: 'fortmaillot', value: 'fortmaillot' }, { text: 'kickitshirts', value: 'kickitshirts' }, { text: 'mailloten', value: 'mailloten' }, { text: 'honorjersey', value: 'honorjersey' }, { text: 'ligafoot', value: 'ligafoot' }, { text: 'beazl', value: 'beazl' }, { text: 'top-w', value: 'top-w' }]"
          prop="tag" -->
          <el-table-column width="105px" label="站点">
            <template slot-scope="scope">
              <div>{{scope.row.site}}</div>
            </template>
          </el-table-column>

          <!-- 订单状态 -->
          <!-- :filtered-value = "['正在处理']"
          :filters="[{ text: '待付款', value: '待付款' }, { text: '正在处理', value: '正在处理' }, { text: '保留', value: '保留' }, { text: '已完成', value: '已完成' }, { text: '已取消', value: '已取消' }, { text: '已退款', value: '已退款' }, { text: '失败订单', value: '失败订单' }]"
          :filter-method="filterTag" -->
          <el-table-column
            width="90px"
            prop="status"
            label="订单状态"
            align="center"
            >
            <template slot-scope="scope">
              <el-tag
              :type="scope.row.status === '待付款' ? 'warning' : (scope.row.status === '正在处理' ? 'primary' : (scope.row.status === '已取消' ? 'info' : (scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败订单' ? 'danger' : 'text'))))"
              disable-transitions>
                {{scope.row.status}}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 订单ID -->
          <!-- sortable -->
          <el-table-column prop="ID_" label="订单ID" width="60px">
          </el-table-column>

          <!-- 商品ID -->
          <el-table-column prop="product_id" label="商品ID" width="150px">
          </el-table-column>

          <!-- 下单时间 -->
          <el-table-column prop="date_created_gmt" label="下单时间" sortable width="95px">
          </el-table-column>

          <!-- 付款时间 -->
          <el-table-column prop="date_paid_gmt" label="付款时间" sortable width="95px">
          </el-table-column>

          <!-- 国际物流单号 -->
          <el-table-column prop="int_no" label="国际物流单号" width="140px">
          </el-table-column>

          <!-- 图片 -->
          <el-table-column label="图片" width="50px">
            <template slot-scope="scope">
              <el-popover placement="right" width="500" trigger="click">
                <img :src="scope.row.img" alt="暂无图片" width="500px" height="500px">
                <img :src="scope.row.img" alt="暂无图片" width="30px" height="30px" slot="reference">
              </el-popover>
            </template>
          </el-table-column>
          <!-- <el-table-column label="图片" width="120px">
            <template slot-scope="scope">
              <img :src="scope.row.img" alt="暂无图片" width="100px" >
            </template>
          </el-table-column> -->

          <!-- 商品名称 -->
          <el-table-column prop="product_name" label="商品名称" width="150px">
          </el-table-column>

          <!-- 定制信息 -->
          <el-table-column label="定制信息">
            <template slot-scope="scope">
              <div><strong style="color:red">尺码:</strong> {{scope.row.size}}</div>
              <div><strong style="color:green">袖标:</strong> {{typeof(scope.row.armband) == 'object' ? '按图' : scope.row.armband}}</div>
              <div><strong style="color:blue">配件:</strong> {{typeof(scope.row.accessories) == 'object' ? '按图' : scope.row.accessories}}</div>
              <div><strong style="color:cyan">字号:</strong> {{scope.row.word_no}}</div>
            </template>
          </el-table-column>

          <!-- 袖标 -->
          <el-table-column label="袖标" width="125">
            <template slot-scope="scope" v-if="typeof(scope.row.armband) == 'object' ? true : false">
              <span v-for="(item,index) in scope.row.armband" :key="index">
                  <el-popover placement="left" trigger="click" width="300">
                    <img :src="item" width="100%" style="background:gray" />
                    <img
                      slot="reference"
                      :src="item"
                      :alt="123"
                      width="48px" height="48px"
                      style="margin:1px;background:gray"
                    />
                  </el-popover>
                </span>
            </template>
          </el-table-column>

          <!-- 配件 -->
          <el-table-column label="配件" width="125">
            <template slot-scope="scope" v-if="typeof(scope.row.accessories) == 'object' ? true : false">
              <span v-for="(item,index) in scope.row.accessories" :key="index">
                  <el-popover placement="left" trigger="click" width="300">
                    <img :src="item" width="100%" />
                    <img
                      slot="reference"
                      :src="item"
                      :alt="123"
                      width="50px" height="50px"
                    />
                  </el-popover>
                </span>
            </template>
          </el-table-column>

          <!-- 数量 -->
          <el-table-column prop="quantity" label="数量" width="40px">
          </el-table-column>

          <!-- 客户备注 -->
          <el-table-column prop="customer_note" label="客户备注"  width="100px">
          </el-table-column>

          <!-- 商品备注 -->
          <el-table-column label="商品备注" width="100px">
            <template slot-scope="scope">
              <!-- <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.product_note placement="top">
                <el-button type="primary" size="mini" v-show="scope.row.product_note">客服备注</el-button>
              </el-tooltip> -->
              <p style="color:red">{{scope.row.product_note}}</p>
              <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.warehouse_note placement="left">
                <el-button style="margin-left: 0;margin-top: 10px;" type="success" size="mini" v-show="scope.row.warehouse_note">仓库备注</el-button>
              </el-tooltip>
              <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.logistics_note placement="bottom">
                <el-button style="margin-left: 0;margin-top: 10px;" type="warning" size="mini" v-show="scope.row.logistics_note">物流备注</el-button>
              </el-tooltip>
            </template>
          </el-table-column>

          <!-- 商品状态 -->
          <!-- :filter-method="filterproduct"
          :filters="[{ text: '待审核', value: '待审核' }, { text: '待发货-制作中', value: '待发货-制作中' }, { text: '待发货', value: '待发货' }, { text: '仓库已发货', value: '仓库已发货' }, { text: '已到货代', value: '已到货代' }, { text: '物流已发货', value: '物流已发货' }, { text: '异常', value: '异常' }, { text: '暂停', value: '暂停' }, { text: '已取消', value: '已取消' }, { text: '已退款', value: '已退款' }, { text: '缺货', value: '缺货' }]" -->
          <el-table-column prop="product_status" label="商品状态" width="130px">
            <template slot-scope="scope">
              <el-tooltip popper-class="text_tooltip" class="item" effect="dark" :content=scope.row.inland_number placement="top">
                <el-button
                  :type="scope.row.product_status === '待审核' ? 'danger' : (scope.row.product_status === '待发货' ? 'warning' : (scope.row.product_status === '待发货-制作中' ? 'info' : (scope.row.product_status === '未提货' ? 'warning' : (scope.row.product_status === '已到货代' ? 'primary' : (scope.row.product_status === '物流已发货' ? 'success' : (scope.row.product_status === '异常' ? 'danger' : (scope.row.product_status === '暂停' ? 'danger' : (scope.row.product_status === '已取消' ? '' : (scope.row.product_status === '已退款' ? 'warning' : (scope.row.product_status === '缺货' ? 'info' : (scope.row.product_status === '待处理' ? 'info' : '')))))))))))" 
                  size="mini">
                    {{scope.row.product_status}}
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>

          <!-- 价格 -->
          <!-- <el-table-column prop="price" label="价格" width="70px">
          </el-table-column> -->

          <!-- 物流方式 -->
          <el-table-column prop="shiptype" label="物流方式" width="60px">
          </el-table-column>

          <!-- 物流商 -->
          <!-- :filter-method = "filterWlS" 
          :filters="[{text:'ST', value:'ST'},{text:'V20', value:'V20'},{text:'66', value:'66'},{text:'WSY', value:'WSY'}]" -->
          <el-table-column prop="wls" label="物流商" width="50px">
          </el-table-column>

          <!-- 定制信息 -->
          <!-- <el-table-column label="定制信息">
            <template slot-scope="scope">
              <div>尺码: {{scope.row.size}}</div>
              <div>袖标：{{scope.row.armband}}</div>
              <div>配件：{{scope.row.accessories}}</div>
              <div>字号：{{scope.row.word_no}}</div>
            </template>
          </el-table-column> -->

          <!-- 是否加急 -->
          <el-table-column :filters="[{text:'是',value:'是'},{text:'否',value:'否'}]" :filter-method="filterHandler" prop='isurgent' label="是否加急" width="55">
            <template slot-scope="scope">
              <span >{{scope.row.isurgent}}</span>
            </template>
          </el-table-column>

          <!-- 操作 编辑 -->
          <el-table-column label="操作" width="50px">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="edit(scope.$index, scope.row)"
                circle
              >
              </el-button>
              <el-button
                style="margin-left: 0;margin-top: 10px;"
                type="primary"
                size="mini"
                icon="el-icon-view"
                @click="look(scope.$index, scope.row)"
                circle
              >
              </el-button>
            </template>
          </el-table-column>

        </el-table>

        <!-- 商品信息弹出框 -->
        <el-dialog title="商品信息" :visible.sync="dialogFormVisible">
          <el-form :model="form">
            <!-- <el-form-item label="商品ID" :label-width="formLabelWidth">
              <el-input v-model="form.product_id" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="商品名称" :label-width="formLabelWidth">
              <el-input v-model="form.product_name" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="客服备注" :label-width="formLabelWidth">
              <el-input v-model="form.product_note" autocomplete="off" placeholder="请输入客服备注" disabled></el-input>
            </el-form-item>
            <el-form-item label="仓库备注" :label-width="formLabelWidth">
              <el-input v-model="form.warehouse_note" autocomplete="off" placeholder="请输入仓库备注" disabled></el-input>
            </el-form-item> -->
            <el-form-item label="物流备注" :label-width="formLabelWidth">
              <el-input v-model="form.logistics_note" autocomplete="off" placeholder="请输入物流备注"></el-input>
            </el-form-item>
            <!-- <el-form-item label="国内快递单号" :label-width="formLabelWidth">
              <el-input :disabled="form.product_status == '仓库已发货' ? false : true" v-model="form.inland_number" autocomplete="off" placeholder="请输入国内快递单号"></el-input>
            </el-form-item> -->
            <el-form-item label="商品状态" :label-width="formLabelWidth">
              <el-select v-model="form.product_status" placeholder="请选择商品状态">
                <el-option label="待审核" value="待审核" disabled></el-option>
                <el-option label="待发货" value="待发货" disabled></el-option>
                <el-option label="待发货-制作中" value="待发货-制作中" disabled></el-option>
                <el-option label="待处理" value="待处理"></el-option>
                <el-option label="未提货" value="未提货" disabled></el-option>
                <el-option label="已到货代" value="已到货代"></el-option>
                <el-option label="物流已发货" value="物流已发货"></el-option>
                <el-option label="异常" value="异常"></el-option>
                <el-option label="暂停" value="暂停"></el-option>
                <el-option label="已取消" value="已取消" disabled></el-option>
                <el-option label="已退款" value="已退款" disabled></el-option>
                <el-option label="缺货" value="缺货" disabled></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="国际物流单号" :label-width="formLabelWidth">
              <el-input v-model="form.int_no" autocomplete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="运输方式" :label-width="formLabelWidth">
              <el-input v-model="form.shiptype" autocomplete="off" disabled></el-input>
            </el-form-item> -->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
          </div>
        </el-dialog>

        <!-- 导出数据二次确认框 -->
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
          <span>您确认要导出选中的数据吗?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleUpload">确 定</el-button>
          </span>
        </el-dialog>

      </el-card>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="pss"
        :page-size="ps"
        :total="Total"
        layout="total, sizes, prev, pager, next, jumper"
        style="display:flex; justify-content: center;">
      </el-pagination>

    </div>
</template>

<script>
import { getProduct,Edit,DC,getProductList,getProductPage } from '../../api/api'
import table2excel from 'js-table2excel'
import imageToBase64 from 'image-to-base64/browser';
export default {
  // inject: ['reload'],
  data() {
    return {

      currentPage: 1,//默认第几页
      pss:[50,100,200,500,700,1000],
      ps:100,//默认每页条数
      Total:0,

      Site:[{ label: 'madrid-shop', value: 'madrid-shop' }, { label: 'cuirz', value: 'cuirz' }, { label: 'nihonbro', value: 'nihonbro' }, { label: 'jleague-shop', value: 'jleague-shop' }, { label: 'supermaillot', value: 'supermaillot' }, { label: 'fortmaillot', value: 'fortmaillot' }, { label: 'kickitshirts', value: 'kickitshirts' }, { label: 'mailloten', value: 'mailloten' }, { label: 'honorjersey', value: 'honorjersey' }, { label: 'ligafoot', value: 'ligafoot' }, { label: 'beazl', value: 'beazl' }, { label: 'top-w', value: 'top-w' }],
      selectSite:[],//筛选站点
      ListStatus:[{ label: '待付款', value: '待付款' }, { label: '正在处理', value: '正在处理' }, { label: '保留', value: '保留' }, { label: '已完成', value: '已完成' }, { label: '已取消', value: '已取消' }, { label: '已退款', value: '已退款' }, { label: '失败订单', value: '失败订单' }],
      selectListStatus:['正在处理'],//筛选订单状态
      ProductStatus:[{ text: '待审核', value: '待审核' }, { text: '待发货', value: '待发货' }, { text: '待发货-制作中', value: '待发货-制作中' }, { text: '待处理', value: '待处理' }, { text: '未提货', value: '未提货' }, { text: '已到货代', value: '已到货代' }, { text: '物流已发货', value: '物流已发货' }, { text: '异常', value: '异常' }, { text: '暂停', value: '暂停' }, { text: '已取消', value: '已取消' }, { text: '已退款', value: '已退款' }, { text: '缺货', value: '缺货' }],//商品状态
      selectProductStatus:[],//筛选商品状态
      WLS:[{text:'ST', value:'ST'},{text:'V20', value:'V20'},{text:'66', value:'66'},{text:'WSY', value:'WSY'},{text:'HB', value:'HB'},{text:'XBH', value:'XBH'}],//物流商
      selectWLS:[],//筛选物流商

      dialogVisible:false,
      dialogFormVisible: false,
      form: {
        // product_id: '',
        // product_name: '',
        // product_note: '',
        // warehouse_note: '',
        // logistics_note: '',
        // inland_number: '',
        // product_status: '',
        // int_no:'',
        // shiptype:'',
        // ID_:'',
        // site:'',
        // status:'',
        // date_paid_gmt:''
      },
      formLabelWidth: '120px',
      tableData: [],//页面展示
      loading: true,
      Data_: [],//导出数据
      input: "",
      value1:[],
    }
  },

  created () {

    // var un = window.localStorage.getItem('un');
    // if(un == '' || un == null || un == undefined){
    //   this.loading = true;
    //   this.$message({
    //     message: '账号密码过期，请重新登录！！！',
    //     type: 'error',
    //     duration:5000
    //   });
    //   return false;
    // }

    var params = {
      Site:this.selectSite,
      ListStatus:this.selectListStatus,
      ProductStatus:this.selectProductStatus,
      WLS:this.selectWLS,
      date_created_gmt:[]
    }
    getProductPage(params).then(res => {
      this.Total = res.length;
    })

    var params = {
      Limit:this.ps,
      Offset:0,
      Site:this.selectSite,
      ListStatus:this.selectListStatus,
      ProductStatus:this.selectProductStatus,
      WLS:this.selectWLS,
      date_created_gmt:[]
    }
    // var abc = [];
    getProductList(params).then(res => {
      for (const i of res) {
        
        if(i.armband == null || i.armband == undefined || i.armband == ''){
          i.armband = '无';
        }
        else if(i.armband.charAt(0) == "h"){
          i.armband = i.armband.split(",");
        }

        if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
          i.accessories = '无';
        }
        else if(i.accessories.charAt(0) == "h"){
          i.accessories = i.accessories.split(",");
        }

        // if(un == 'CKWJ'){
        //   un = 'ST';
        // }

        // if(i.wls == un){
        //   abc.push(i);
        // }
      }
      this.tableData = res;
      this.loading = false;
    })

  },
  
  methods: {

    // 筛选是否加急
    filterHandler(value, row) {
      if(value === '否'){
        return row.isurgent === '';
      }else{
        return row.isurgent === value;
      }
    },

    //设置每页几条
    handleSizeChange(val) {
      this.loading = true;
      this.ps = val;
      var limit = val;
      var offset = (this.currentPage - 1) * val;
      var params = {
        Limit:limit,
        Offset:offset,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        ProductStatus:this.selectProductStatus,
        WLS:this.selectWLS,
        date_created_gmt:[]
      }
      getProductList(params).then(res => {
        for (const i of res) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }
        }
        this.tableData = res;
        this.loading = false;
      })
    },

    //前往第几页
    handleCurrentChange(val) {
      this.loading = true;
      this.currentPage = val;
      var limit = this.ps;
      var offset = (val - 1) * this.ps;
      var params = {
        Limit:limit,
        Offset:offset,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        ProductStatus:this.selectProductStatus,
        WLS:this.selectWLS,
        date_created_gmt:[]
      }
      getProductList(params).then(res => {
        for (const i of res) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }
        }
        this.tableData = res;
        this.loading = false;
      })
    },

    // 查询订单
    CXDD(){
      this.loading = true;
      var params = {
        Limit:this.ps,
        Offset:(this.currentPage - 1) * this.ps,
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        ProductStatus:this.selectProductStatus,
        WLS:this.selectWLS,
        date_created_gmt:[]
      }

      getProductList(params).then(res => {
        for (const i of res) {
          if(i.armband == null || i.armband == undefined || i.armband == ''){
            i.armband = '无';
          }
          else if(i.armband.charAt(0) == "h"){
            i.armband = i.armband.split(",");
          }

          if(i.accessories == null || i.accessories == undefined || i.accessories == ''){
            i.accessories = '无';
          }
          else if(i.accessories.charAt(0) == "h"){
            i.accessories = i.accessories.split(",");
          }
        }
        this.tableData = res;
        this.loading = false;
      })

      var params = {
        Site:this.selectSite,
        ListStatus:this.selectListStatus,
        ProductStatus:this.selectProductStatus,
        WLS:this.selectWLS,
        date_created_gmt:[]
      }

      getProductPage(params).then(res => {
        this.Total = res.length;
      })
    },

    // X(导出数据)
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },

    //导出数据(二次确认)
    export_(){
      this.dialogVisible = true;
    },

    //导出数据(确认导出)
    handleUpload(){
      this.dialogVisible = false;
      if(this.Data_.length == 0){
        this.$message({
          message: "导出数据为空,请先选中您要导出的数据",
          type: "warning",
          showClose: true
        })
        return false;
      }
      const column = [
        {
          title: '站点',
          key: 'site',
          type:'text'
        },
        {
          title: '订单id', 
          key: 'ID_',
          type: 'text'
        },
        {
          title: '商品id',
          key: 'product_id',
          type: 'text'
        },
        {
          title: '支付时间', 
          key: 'date_paid_gmt',
          type: 'text'
        },
        {
          title: '产品图片',
          key: 'img',
          type: 'image',
          width: 120,
          height: 110
        },
        {
          title: '产品名称',
          key: 'product_name',
          type: 'text'
        },
        {
          title: '定制信息',
          key: 'pro_det',
          type: 'text'
        },
        {
          title: '袖标1',
          key: 'armband1',
          type: 'image',
          width: 80,
          height: 80
        },
        {
          title: '袖标2',
          key: 'armband2',
          type: 'image',
          width: 80,
          height: 80
        },
        {
          title: '袖标3',
          key: 'armband3',
          type: 'image',
          width: 80,
          height: 80
        },
        {
          title: '袖标4',
          key: 'armband4',
          type: 'image',
          width: 80,
          height: 80
        },
        {
          title: '袖标5',
          key: 'armband5',
          type: 'image',
          width: 80,
          height: 80
        },
        {
          title: '袖标6',
          key: 'armband6',
          type: 'image',
          width: 80,
          height: 80
        },
        {
          title: '配件1',
          key: 'accessories1',
          type: 'image',
          width: 80,
          height: 80
        },
        {
          title: '配件2',
          key: 'accessories2',
          type: 'image',
          width: 80,
          height: 80
        },
        {
          title: '客户备注',
          key: 'customer_note',
          type: 'text'
        },
        {
          title: '数量',
          key: 'quantity',
          type: 'text'
        },
        {
          title: '运输方式',
          key: 'shiptype',
          type: 'text'
        },
        {
          title: '客服备注',
          key: 'product_note',
          type: 'text'
        },
        {
          title: '商品状态',
          key: 'product_status',
          type: 'text'
        },
        {
          title: '国内单号',
          key: 'a',
          type: 'text'
        },
        {
          title: '订单号',
          key: 'a',
          type: 'text'
        },
        {
          title: '转单号',
          key: 'a',
          type: 'text'
        },
        {
          title: '到货情况',
          key: 'a',
          type: 'text'
        },
        {
          title: '发货状态',
          key: 'a',
          type: 'text'
        },
        {
          title: '发货日期',
          key: 'a',
          type: 'text'
        }
      ]
      table2excel(column, this.Data_, "订单列表.xls");
      // var abc = [];
      // for(var i of this.Data_){
      //   i.product_status = "待发货-制作中";
      //   abc.push(i.product_id);
      // }
      // var params = {
      //   "product_id":abc,
      //   "product_status":"待发货-制作中"
      // };
      // DC(params).then(res => {});
    },

    //编辑
    edit(index,row){
      // console.log(row);

      // var un = window.localStorage.getItem('un');
      // if(un == '' || un == null || un == undefined){
      //   this.loading = true;
      //   this.$message({
      //     message: '账号密码过期，请重新登录！！！',
      //     type: 'error',
      //     duration:5000
      //   });
      //   return false;
      // }

      this.dialogFormVisible = true;
      this.form = {
        product_id: row.product_id,
        // product_name: row.product_name,
        // product_note: row.product_note,
        // warehouse_note: row.warehouse_note,
        logistics_note: row.logistics_note,
        // inland_number: row.inland_number,
        product_status: row.product_status,
        int_no: row.int_no,
        shiptype: row.shiptype,
        ID_: row.ID_,
        site: row.site,
        status: row.status,
        date_paid_gmt: row.date_paid_gmt
      }
    },

    //取消编辑
    cancel(){
      this.dialogFormVisible = false;
      this.$message('取消编辑成功！！！');
    },

    //确定编辑
    confirm(){
      // if((this.form.int_no == '' || this.form.int_no == undefined) && this.form.product_status == "物流已发货"){
      if((this.form.int_no == '' || this.form.int_no == undefined) && this.form.product_status == "TMD"){
        this.$message({
          message:'物流已发货时，国际物流单号不能为空！！！',
          type:'error'
        })
        return false;
      }else{
        var timee = new Date();
        var timeee = this.$moment(timee.getTime()).format("YYYY-MM-DD HH:mm:ss");
        var params = {
          product_id: this.form.product_id,
          // product_name: this.form.product_name,
          // product_note:this.form.product_note,
          // warehouse_note:this.form.warehouse_note,
          logistics_note:this.form.logistics_note,
          // inland_number:this.form.inland_number,
          product_status:this.form.product_status,
          int_no:this.form.int_no,
          shiptype:this.form.shiptype,
          ID_:this.form.ID_,
          site:this.form.site,
          status:this.form.status,
          date_paid_gmt:this.form.date_paid_gmt,
          person:'CKWJ',
          time:timeee
        };
        Edit(params).then(res => {
          if(res.code === 200){
            this.loading = true;
            for(var i of this.tableData){
              if(i.product_id == this.form.product_id){
                // i.product_name = this.form.product_name;
                // i.product_note = this.form.product_note;
                // i.warehouse_note = this.form.warehouse_note;
                i.logistics_note = this.form.logistics_note;
                // i.inland_number = this.form.inland_number;
                i.product_status = this.form.product_status;
                // i.int_no = this.form.int_no;
                // i.shiptype = this.form.shiptype;
              }
            }
            this.loading = false;
            this.$message({
              message: '编辑成功！！！',
              type: 'success'
            });
          }else{
            this.$message({
              message: '编辑失败！！！',
              type: 'error'
            });
          }
        }).catch((error) => {
          console.log(error);
        });
        this.dialogFormVisible = false;
      }
      // // this.reload();
    },

    //查看详情
    look(index, row){
      const routeData = this.$router.resolve({ path: "/home/Orderdetail_", query: { site: row.site, ID_: row.ID_ } });
      window.open(routeData.href, '_blank');
    },

    //复选框
    selectionChange(selection){
      // console.log(selection);
      for(var k = 0;k < selection.length;k++){
        if(selection[k].a == undefined){
          selection[k].a = '';
        }
        // if(selection[k].pro_det == undefined){
        //   selection[k].pro_det = `<br/>配件:${selection[k].accessories}<br/>字号:${selection[k].word_no}<br/>尺码:${selection[k].size}<br/>袖标:${selection[k].armband}`;
        // }
        // if(selection[k].customer_note == null){
        //   selection[k].customer_note = '无';
        // }

        // 定制信息
        if(selection[k].pro_det == undefined){
          selection[k].pro_det = '<br/>配件:' + (typeof(selection[k].accessories) == 'object' ? '按图' : selection[k].accessories) + `<br/>字号:${selection[k].word_no}<br/>尺码:${selection[k].size}<br/>袖标:` + (typeof(selection[k].armband) == 'object' ? '按图' : selection[k].armband);
        }

        // 格式化支付时间
        // selection[k].date_paid_gmt = this.$moment(selection[k].date_paid_gmt).format('YY-MM-DD');

        // 整合袖标图片
        if(typeof(selection[k].armband) == 'object'){
          // 将袖标字符串转化为数组
          var ddd = selection[k].armband;
          // 袖标数组长度
          var ttt = selection[k].armband.length;
          if(ttt == 0){
            if(selection[k].armband1 == undefined){
              selection[k].armband1 = '无';
            }
            if(selection[k].armband2 == undefined){
              selection[k].armband2 = "无";
            }
            if(selection[k].armband3 == undefined){
              selection[k].armband3 = "无";
            }
            if(selection[k].armband4 == undefined){
              selection[k].armband4 = "无";
            }
            if(selection[k].armband5 == undefined){
              selection[k].armband5 = "无";
            }
            if(selection[k].armband6 == undefined){
              selection[k].armband6 = "无";
            }
          }
          else if(ttt == 1){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = "无";
                }
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = "无";
                }
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = "无";
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }
            }
          }
          else if(ttt == 2){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = "无";
                }
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = "无";
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 3){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = "无";
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 4){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = "无";
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }else if(i == 3){
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 5){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = "无";
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }else if(i == 3){
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = ddd[i];
                }
              }else if(i == 4){
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = ddd[i];
                }
              }
            }
          }
          else if(ttt == 6){
            for(var i = 0;i < ttt;i++){
              if(i == 0){
                if(selection[k].armband1 == undefined){
                  selection[k].armband1 = ddd[i];
                }
              }else if(i == 1){
                if(selection[k].armband2 == undefined){
                  selection[k].armband2 = ddd[i];
                }
              }else if(i == 2){
                if(selection[k].armband3 == undefined){
                  selection[k].armband3 = ddd[i];
                }
              }else if(i == 3){
                if(selection[k].armband4 == undefined){
                  selection[k].armband4 = ddd[i];
                }
              }else if(i == 4){
                if(selection[k].armband5 == undefined){
                  selection[k].armband5 = ddd[i];
                }
              }else if(i == 5){
                if(selection[k].armband6 == undefined){
                  selection[k].armband6 = ddd[i];
                }
              }
            }
          }
        }

        // 整合配件图片
        if(typeof(selection[k].accessories) == 'object'){
          var sss = selection[k].accessories;
          var ggg = selection[k].accessories.length;
          if(ggg == 0){
            if(selection[k].accessories1 == undefined){
              selection[k].accessories1 = '无';
            }
            if(selection[k].accessories2 == undefined){
              selection[k].accessories2 = '无';
            }
          }
          else if(ggg == 1){
            for(var p = 0;p < ggg;p++){
              if(p == 0){
                if(selection[k].accessories1 == undefined){
                  selection[k].accessories1 = sss[p];
                }
                if(selection[k].accessories2 == undefined){
                  selection[k].accessories2 = '无';
                }
              }
            }
          }
          else if(ggg == 2){
            for(var p = 0;p < ggg;p++){
              if(p == 0){
                if(selection[k].accessories1 == undefined){
                  selection[k].accessories1 = sss[p];
                }
              }else if(p == 1){
                if(selection[k].accessories2 == undefined){
                  selection[k].accessories2 = sss[p];
                }
              }
            }
          }
        }

      }

      for(let i of this.Data_){
        imageToBase64(i.img).then((response) => 
          {
            // console.log('data:image/jpeg;base64,' + response);
            i.img = 'data:image/jpeg;base64,' + response
          }).catch((error) => 
          {
            console.log(error);
          })
      }

      this.Data_ = selection;

    },
    
    // 店铺筛选
    filter(value, row) {
      return row.site === value;
    },

    // 状态筛选
    filterTag(value, row) {
      return row.status === value;
    },

    // 商品状态筛选
    filterproduct(value, row){
      return row.product_status === value;
    },

    // 物流商筛选
    filterWlS(value, row){
      return row.wls === value;
    },

    //搜索
    search(){
      const search__ = this.$router.resolve({ path: "/home/search_", query: { id: this.input}});
      window.open(search__.href, '_blank');
    },

    //重置
    reset(){
      this.loading = true;
      this.input = "";
      getProduct().then(res => {
        for(var i = 0;i < res.length;i++){
          if(res[i].armband == '' || res[i].armband == null){
            res[i].armband = "无";
          }
          if(res[i].accessories == '' || res[i].accessories == null){
            res[i].accessories = "无";
          }
          if(res[i].word_no == '' || res[i].word_no == null){
            res[i].word_no = "无";
          }
        }
        this.tableData = res;
        this.loading = false;
      })
    },

    //时间格式化
    utc2timestamp(utc_datetime) {
      // 处理成为时间戳
      var timestamp = new Date(Date.parse(utc_datetime));
      timestamp = timestamp.getTime();
      return timestamp;
    },

    //时间范围筛选
    block(time){
      if(!time){
        this.value1 = [];
      }
      var timestamp,timestamp_ = '';
      timestamp = Date.parse(this.value1[0]);
      timestamp_ = Date.parse(this.value1[1]);
      console.log(timestamp,timestamp_);
      var arr = [];
      getProduct().then(res => {
        for(var i = 0;i < res.length;i++){
          var Time = this.utc2timestamp(res[i].date_paid_gmt);
          console.log(Time);
          if(Time > timestamp && Time < timestamp_){
            arr.push(res[i]);
          }
        }
        this.tableData = arr;
      })
      console.log(arr);
    },
  },
  
}
</script>

<style lang="scss" scoped>
  .head{
    margin-bottom: 20px;
    .block{
      display: inline-block;
      margin-left: 20px;
    }
  }
  // 隐藏数字输入框后面的上下调节按钮
  /deep/ input::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    appearance: none !important;
  }
  /deep/ input[type="number"] {
    -moz-appearance: textfield !important;
    appearance: textfield !important;
  }
</style>
<style lang="scss">
  .el-tooltip__popper{
    max-width: 200px !important;
  }
</style>